import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import { errorReceiveAllLockers, errorReceiveSiteLockers, failedReceiveAllLockers, failedReceiveSiteLockers } from '../lockers/slice';
import customersInfoState from './state';
const customersInfoSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => customersInfoState).addCase(errorReceiveAllLockers, state => {
            state.allCustomersInfo = undefined;
            state.receivingAllCustomersInfo = false;
        }).addCase(errorReceiveSiteLockers, state => {
            state.customersInfo = undefined;
            state.receivingCustomersInfo = false;
        }).addCase(failedReceiveAllLockers, state => {
            state.allCustomersInfo = undefined;
            state.receivingAllCustomersInfo = false;
        }).addCase(failedReceiveSiteLockers, state => {
            state.customersInfo = undefined;
            state.receivingCustomersInfo = false;
        });
    },
    initialState: customersInfoState,
    name: 'customersInfo',
    reducers: {
        errorReceiveAllCalculatedCustomersInfo: state => {
            state.allCustomersInfo = undefined;
            state.receivingAllCustomersInfo = false;
        },
        errorReceiveCalculatedCustomersInfo: state => {
            state.customersInfo = undefined;
            state.receivingCustomersInfo = false;
        },
        failedReceiveAllCalculatedCustomersInfo: state => {
            state.allCustomersInfo = undefined;
            state.receivingAllCustomersInfo = false;
        },
        failedReceiveCalculatedCustomersInfo: state => {
            state.customersInfo = undefined;
            state.receivingCustomersInfo = false;
        },
        receiveAllCalculatedCustomersInfo: {
            prepare: allCustomersInfo => {
                return {
                    payload: {
                        allCustomersInfo
                    }
                };
            },
            reducer: (state, action) => {
                const { allCustomersInfo } = action.payload;
                state.allCustomersInfo = allCustomersInfo;
                state.receivingAllCustomersInfo = false;
            }
        },
        receiveAllCustomersInfo: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.receivingAllCustomersInfo = true;
            }
        },
        receiveCalculatedCustomersInfo: {
            prepare: customersInfo => {
                return {
                    payload: {
                        customersInfo
                    }
                };
            },
            reducer: (state, action) => {
                const { customersInfo } = action.payload;
                state.customersInfo = customersInfo;
                state.receivingCustomersInfo = false;
            }
        },
        receiveCustomersInfo: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.receivingCustomersInfo = true;
            }
        },
        resetCustomersInfo: () => customersInfoState
    }
});
export const { errorReceiveAllCalculatedCustomersInfo, errorReceiveCalculatedCustomersInfo, failedReceiveAllCalculatedCustomersInfo, failedReceiveCalculatedCustomersInfo, receiveAllCalculatedCustomersInfo, receiveAllCustomersInfo, receiveCalculatedCustomersInfo, receiveCustomersInfo, resetCustomersInfo } = customersInfoSlice.actions;
export default customersInfoSlice.reducer;
